import {
    listenToMessage,
    ReceivedMessageType,
} from '@om-fe/core/utils/parent-communication';
import { withSelectionBetslipData } from '@om-fe/widgets/dist/widgets/betslip/with-betslip-selection-data/with-betslip-selection-data';
import React, { MutableRefObject, useCallback, useEffect, useState } from 'react';
import { compose } from 'redux';
import { BetslipOpenBetsTabs, BetslipTabs } from './betslip-tabs';
import { BetslipTaxes } from './betslip-taxes';

export interface BetslipOpenBetsWithoutSessionProps {
    readonly className?: string;
    readonly openModal?: () => void;
    readonly closeModal?: () => void;
    readonly parentContainerRef: MutableRefObject<React.ReactNode>;
    readonly onTabChanged?: (tab: BetslipOpenBetsTabs) => void;
}

export interface BetslipOpenBetsWithoutSessionStoreProps {
    readonly selectionList: string[];
}

const BetslipOpenBetsWithoutSessionComponent = (
    {
        selectionList,
        openModal,
        closeModal,
        parentContainerRef,
        onTabChanged,
    }: BetslipOpenBetsWithoutSessionProps & BetslipOpenBetsWithoutSessionStoreProps) => {
    const [selectedTab, setSelectedTab] = useState<BetslipOpenBetsTabs>(BetslipOpenBetsTabs.BetSlip);
    const handleSelectTab = useCallback((tab: BetslipOpenBetsTabs) => {
        onTabChanged?.(tab);
        setSelectedTab(tab);
    }, [onTabChanged]);

    useEffect(() => {
        setSelectedTab(BetslipOpenBetsTabs.BetSlip);
    }, [selectionList]);

    useEffect(() => {
        return listenToMessage('OP:showBetslip' as ReceivedMessageType, () => {
            setSelectedTab(BetslipOpenBetsTabs.BetSlip);
        });
    }, []);

    return (
        <>
            <BetslipTabs
                selectedTab={selectedTab}
                openBetsCount={undefined}
                onTabClick={handleSelectTab}
                closeModal={closeModal}
            />
            {(selectedTab === BetslipOpenBetsTabs.BetSlip) && (
                <BetslipTaxes
                    parentContainerRef={parentContainerRef}
                    openModal={openModal}
                    closeModal={closeModal}
                />
            )}
        </>
    );
};

export const BetslipOpenBetsWithoutSession: React.ComponentType<BetslipOpenBetsWithoutSessionProps> = compose<BetslipOpenBetsWithoutSessionProps>(
    withSelectionBetslipData(),
)(BetslipOpenBetsWithoutSessionComponent);